import React from 'react'; 
import { MainContainer, SidePanel, Article, HeadGear } from 'Templates';
import * as Section from './Sections';
import * as Table from './Tables';

const Draggerjs = () => { 
	const title = 'Draggerjs (not publish yet)';
	const context = `is a pure vanila javascript without dependency which is use to drag and drop elements in easy and understabdable way.`;

	return (
		<>
			<HeadGear>
			 	<HeadGear.Meta 
					title={`${title} - Javascript Libraries | Mytabworks `}
					description={context}
					image='/images/icons/icon-512x512.png'
				/>
			</HeadGear>
			<MainContainer 
				title={title}
				context={context}
				main={<DraggerjsMain />}
				side={<DraggerjsSidePanel />}
			/>
		</>
	);
};

Draggerjs.propTypes = {}; 

const DraggerjsMain = () => (
	<>
		<Section.Installation />
		<Section.Importing />
		<Section.GettingStarted /> 
		<Section.Autoscroll />
		<Section.RawDrag />
		<Section.Droppable />
		<Section.Cloning />
		<Section.Switching />
		<Article title='API'>
			<Table.Dragger /> 
			<Table.Methods /> 
			<Table.EventProp />
		</Article>
	</>
);

const DraggerjsSidePanel = () => {
	const list = [
		{ label: 'Installation' },
		{ label: 'Imports' },
		{
			label: 'Getting Started',
			sub: [
				{ label: 'Autoscroll' },
				{ label: 'Raw Draggable' },
				{ label: 'Droppable' },
				{ label: 'Cloning' },
				{ label: 'Switching' },
			],
		},
		{
			label: 'API',
			sub: [
				{ label: 'Dragger' },
				{ label: 'Dragger Methods' },
				{ label: 'Event Properties' },
			],
		},
	];
	return <SidePanel.ScrollNav list={list} />;
};

export default Draggerjs